import { render, staticRenderFns } from "./DucNoticeListItem.vue?vue&type=template&id=3f26c919&scoped=true"
import script from "./DucNoticeListItem.vue?vue&type=script&lang=js"
export * from "./DucNoticeListItem.vue?vue&type=script&lang=js"
import style0 from "./DucNoticeListItem.vue?vue&type=style&index=0&id=3f26c919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26c919",
  null
  
)

export default component.exports